module.exports = __webpack_public_path__ + "static/media/location.a124ebbb.svg";